import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public setItem(key: string, value: any) {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), constants.ENCRYPTION_KEY).toString();
    localStorage.setItem(key, encryptedValue);
  }

  public getItem(key: string) {
    const storageValue = localStorage.getItem(key);
    if (storageValue) {
      const decryptedValue = CryptoJS.AES.decrypt(storageValue, constants.ENCRYPTION_KEY);
      const value = decryptedValue.toString(CryptoJS.enc.Utf8);
      if (value) {
        return JSON.parse(decryptedValue.toString(CryptoJS.enc.Utf8));
      }
    }
  }

  public get key() {
    return localStorage.getItem(constants.LM_KEY);
  }

  public removeItem(key: string) {
    localStorage.removeItem(key);
  }

  public isKeyExist(key: string) {
    return localStorage.getItem(key) !== null;
  }

  static getItem(key: string) {
    const storageValue = localStorage.getItem(key);
    if (storageValue) {
      const decryptedValue = CryptoJS.AES.decrypt(storageValue, constants.ENCRYPTION_KEY);
      const value = decryptedValue.toString(CryptoJS.enc.Utf8);
      if (value) {
        return JSON.parse(decryptedValue.toString(CryptoJS.enc.Utf8));
      }
    }
  }
}
